"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/col/style/css");

var _col = _interopRequireDefault(require("antd/es/col"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

var _react = _interopRequireWildcard(require("react"));

var _form = _interopRequireDefault(require("antd/lib/form"));

var _ActivityImageUpload = _interopRequireDefault(require("../ActivityImageUpload"));

var _ActivityGradientSelector = _interopRequireDefault(require("../ActivityGradientSelector"));

require("../activity.scss");

var _ActivityPreview = _interopRequireDefault(require("../ActivityPreview"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const {
  Option
} = _select.default;

class ActivityBackgroundForm extends _react.Component {
  constructor() {
    super(...arguments);
    this.form = /*#__PURE__*/_react.default.createRef();

    this.onChange = type => {
      const {
        setBackgroundType
      } = this.props;
      setBackgroundType(type);
    };

    this.setGradient = (start, end) => {
      const {
        setActivity
      } = this.props;
      const background = {
        gradient: {
          start,
          end
        }
      };
      setActivity({
        background
      });
    };

    this.validate = (rule, value) => {
      const {
        backgroundType: type,
        previewImage,
        background,
        creative,
        editable
      } = this.props;

      if (background) {
        const {
          gradient
        } = background;

        try {
          if (!creative && !editable) {
            return Promise.resolve();
          }

          if (type === 'image' && previewImage.length === 0) {
            throw new Error('Image upload is required.');
          } else if (type === 'gradient' && !gradient) {
            throw new Error('Gradient is required.');
          }

          return Promise.resolve();
        } catch (err) {
          return Promise.reject(err);
        }
      }
    };

    this.resetForm = () => {
      if (this.form.current) {
        this.form.current.resetFields();
      }
    };
  }

  componentDidMount() {
    const {
      setActiveForm
    } = this.props;
    setActiveForm(this.form.current);
  }

  render() {
    const {
      image,
      uploadFile,
      removeFile,
      previewImage,
      backgroundType,
      background,
      creative,
      editable
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-form"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "background-form",
      layout: "vertical",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "question-switch"
    }, /*#__PURE__*/_react.default.createElement(Item, {
      label: "Please select the background type:",
      name: "backgroundType",
      required: true,
      initialValue: backgroundType
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      disabled: !creative && !editable,
      style: {
        width: 120
      },
      onChange: this.onChange
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "image"
    }, "Image"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "gradient"
    }, "Gradient")))), /*#__PURE__*/_react.default.createElement("span", null, backgroundType === 'image' ? 'Please choose an image to upload.' : 'Please select two colors for the gradient background.')), /*#__PURE__*/_react.default.createElement(Item, {
      name: "background",
      rules: [{
        required: true,
        validator: this.validate
      }],
      validateTrigger: ['onChange', 'onSubmit', 'onBlur', 'onFocus']
    }, backgroundType === 'image' ? /*#__PURE__*/_react.default.createElement(_ActivityImageUpload.default, {
      disabled: !creative && !editable,
      image: image,
      uploadFile: uploadFile,
      removeFile: removeFile
    }) : /*#__PURE__*/_react.default.createElement(_ActivityGradientSelector.default, {
      disabled: !creative && !editable,
      gradient: background === null || background === void 0 ? void 0 : background.gradient,
      setGradient: this.setGradient
    })))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(_ActivityPreview.default, {
      creative: creative,
      editable: editable,
      background: background,
      backgroundType: backgroundType,
      imageFile: image,
      previewImage: previewImage
    })));
  }

}

var _default = ActivityBackgroundForm;
exports.default = _default;